export default "__VITE_ASSET__CdAtqvK8__"